module.exports = __webpack_public_path__ + "img/cementos-chihuahua.82a437e3.png";